import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import CmsTools from '../../../CmsTools/CmsTools';
import './Download.scss';

const Download = ({ id, size }) => {
  const {
    dataUrlBase,
    courseId,
    assetManifest,
    dataUrl,
    language
  } = useSelector(
    state => ({
      dataUrlBase: state.CourseState.dataUrlBase,
      courseId: state.CourseState.courseId,
      assetManifest: state.BlockState.assetManifest,
      dataUrl: state.BlockState.dataUrl,
      language: state.CourseState.language
    }),
    shallowEqual
  );

  let asset = assetManifest.assets.find(a => a.id === id || a.importId === id);

  let localizedFile =
    language.code === 'en-US'
      ? asset.file
      : asset.file
          .replace('.pka', `_${language.code}.pka`)
          .replace('.pkt', `_${language.code}.pkt`);

  return (
    <div
      className="download-btn"
      style={{ margin: '0 10% 15px', position: 'relative' }}
    >
      <iframe
        title={`#pka-title-${asset.id}`}
        id={`#pka-dl-${asset.id}`}
        style={{ display: 'none' }}
      ></iframe>
      <CmsTools id={id} type="assets" subtype="pka" />
      <a
        style={{ maxWidth: '100%', width: '100%' }}
        className={`btn btn--primary btn--${size}`}
        download
        title={asset.description}
        href={`${
          asset.common
            ? `${dataUrlBase}/${courseId}/_common/`
            : `${dataUrl}assets/`
        }${localizedFile}`}
      >
        <span className="icon-download"></span> {asset.description}
      </a>
    </div>
  );
};

Download.defaultProps = {
  size: 'wide'
};

export default Download;
